import { Grid, Typography } from '@material-ui/core';
import { JobEdge } from 'graphql/generated';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Carousel } from '..';
import { useStyle } from './related-jobs.style';

type RelatedJobsProps = {
    relatedJobs: JobEdge[];
};

export const RelatedJobs: React.FC<RelatedJobsProps> = ({ relatedJobs }) => {
    const classes = useStyle();
    const { t } = useTranslation();

    return (
        <Grid container item xs={12}>
            <Grid item xs={12}>
                <Typography variant="h4">{t('jobDetails:similarJobs')}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.carousel}>
                <Carousel data={relatedJobs} />
            </Grid>
        </Grid>
    );
};
